import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
export const Root = styled.hr `
  all: unset;
  display: block;
  background: ${(props) => props.$variant === 'solid'
    ? // eslint-disable-next-line prettier/prettier
        props.$color ?? 'currentColor'
    : `linear-gradient(
    ${props.$vertical ? '0deg' : '90deg'},
    transparent 0%,
    rgba(var(--background-11-rgb), ${props.$opacityMaxPercent ?? 20}%) 50%,
    transparent 100%
  )`};
  height: ${(props) => (props.$vertical ? '100%' : '1px')};
  width: ${(props) => props.$vertical ? '1px' : props.$fullWidth ? '100%' : 'auto'};
`;
export const Separator = (props) => (_jsx(Root, { ref: props.ref, "$vertical": props.vertical, "$variant": props.variant, "$fullWidth": props.fullWidth, "$opacityMaxPercent": props.variant === 'gradient' ? props.opacityMaxPercent : undefined, "$color": props.variant === 'solid' ? props.color : undefined, className: props.className }));
//# sourceMappingURL=separator.js.map